@if (view$ | async; as results) {
    @if (results.resultsExists) {
        <div class="table-responsive w-100">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        @for (head of columnHeads; track $index) {
                            @if (
                                (head.operator.length === 0 ||
                                    head.operator.includes(consumptionAgent?.operator ?? '')) &&
                                (head.consumptionToMonitor.length === 0 ||
                                    head.consumptionToMonitor.includes(
                                        consumptionAgent?.consumptionToMonitor ?? ''
                                    ))
                            ) {
                                @switch (head.column) {
                                    @case ('monitoringConsumption') {
                                        <th
                                            app-sortable-table-header
                                            [column]="head.column"
                                            (sort)="onSort($event)"
                                            label="{{ head.label }} {{
                                                results.resultSubject?.monitoringPeriod?.startDate
                                                    | appdate
                                            }} - {{
                                                results.resultSubject?.monitoringPeriod?.endDate
                                                    | appdate
                                            }}"></th>
                                    }
                                    @case ('comparisonConsumption') {
                                        <th
                                            app-sortable-table-header
                                            [column]="head.column"
                                            (sort)="onSort($event)"
                                            label="{{ head.label }} {{
                                                results.resultSubject?.comparisonPeriod?.startDate
                                                    | appdate
                                            }} - {{
                                                results.resultSubject?.comparisonPeriod?.endDate
                                                    | appdate
                                            }}"></th>
                                    }
                                    @case ('meterGroupName') {
                                        <th
                                            app-sortable-table-header
                                            [column]="head.column"
                                            (sort)="onSort($event)"
                                            [label]="head.label"></th>
                                    }
                                    @default {
                                        <th
                                            app-sortable-table-header
                                            [column]="head.column"
                                            (sort)="onSort($event)"
                                            [label]="head.label"></th>
                                    }
                                }
                            }
                        }
                    </tr>
                    <tr [formGroup]="formGroupFilter">
                        @for (head of columnHeads; track $index) {
                            @if (
                                (head.operator.length === 0 ||
                                    head.operator.includes(consumptionAgent?.operator ?? '')) &&
                                (head.consumptionToMonitor.length === 0 ||
                                    head.consumptionToMonitor.includes(
                                        consumptionAgent?.consumptionToMonitor ?? ''
                                    ))
                            ) {
                                <th class="align-top">
                                    @if (head.formType === 'selectMultiple') {
                                        <app-input-dropdown-checkboxes
                                            [formControl]="
                                                head.formControl
                                            "></app-input-dropdown-checkboxes>
                                    }
                                    @if (head.formType === 'text') {
                                        <app-input-text-group
                                            [formControl]="head.formControl"></app-input-text-group>
                                    }
                                    @if (head.formType === 'dateTime') {
                                        <app-input-date-group [formControl]="head.formControl" />
                                    }
                                </th>
                            }
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (
                        consumption of (results.sortedPercentageMeterConsumptions.length > 0
                            ? results.sortedPercentageMeterConsumptions
                            : results.sortedMeterConsumptions
                        )
                            | slice
                                : (results.page - 1) * results.pageSize
                                : results.page * results.pageSize;
                        track $index
                    ) {
                        <tr>
                            @for (head of columnHeads; track $index) {
                                @if (head.column; as column) {
                                    @if (
                                        (head.operator.length === 0 ||
                                            head.operator.includes(
                                                consumptionAgent?.operator ?? ''
                                            )) &&
                                        (head.consumptionToMonitor.length === 0 ||
                                            head.consumptionToMonitor.includes(
                                                consumptionAgent?.consumptionToMonitor ?? ''
                                            ))
                                    ) {
                                        <td class="text-nowrap">
                                            @switch (head.formType) {
                                                @case ('dateTime') {
                                                    @if (
                                                        column === 'mountingDate' ||
                                                        column === 'dismountedDate'
                                                    ) {
                                                        {{ consumption[column] | appdate }}
                                                    }
                                                }
                                                @case ('selectMultiple') {
                                                    @if (column === 'meterTypeNo') {
                                                        {{
                                                            'mappers_meterType.' +
                                                                consumption.meterTypeNo
                                                                | translate: 'online' : 'common'
                                                        }}
                                                    }
                                                    @if (column === 'alloUnitType') {
                                                        {{
                                                            'mappers_allocationUnitMap.' +
                                                                consumption.alloUnitType
                                                                | translate: 'online' : 'common'
                                                        }}
                                                    }
                                                    @if (column === 'unit') {
                                                        {{
                                                            'common_UNIT_DESC_' + consumption.unit
                                                                | translate: 'online' : 'common'
                                                        }}
                                                    }
                                                    @if (column === 'meterGroupName') {
                                                        {{ consumption.meterGroupName }}
                                                    }
                                                }
                                                @case ('text') {
                                                    @if (
                                                        column === 'meterId' ||
                                                        column === 'meterNo' ||
                                                        column === 'replacedBy' ||
                                                        column === 'unit' ||
                                                        column === 'meterGroupName' ||
                                                        column === 'address' ||
                                                        column === 'placement'
                                                    ) {
                                                        {{ consumption[column] }}
                                                    }
                                                    @if (column === 'proBraLoc') {
                                                        {{
                                                            (consumption.propertyNo != null
                                                                ? consumption.propertyNo
                                                                : '') +
                                                                (consumption.branchNo != null
                                                                    ? '-' + consumption.branchNo
                                                                    : '') +
                                                                (consumption.locationNo != null
                                                                    ? '-' + consumption.locationNo
                                                                    : '')
                                                        }}
                                                    }

                                                    @if (column === 'monitoringConsumption') {
                                                        {{ consumption[column] | appnumber }}
                                                    }
                                                    @if (
                                                        isPercentageMeterConsumption(consumption)
                                                    ) {
                                                        @if (column === 'diff') {
                                                            {{ consumption[column] | appnumber }}
                                                        }
                                                        @if (column === 'diffInPercentage') {
                                                            {{ consumption[column] | appnumber }}
                                                        }
                                                        @if (column === 'comparisonConsumption') {
                                                            {{ consumption[column] | appnumber }}
                                                        }
                                                    }
                                                }
                                                @default {}
                                            }
                                        </td>
                                    }
                                }
                            }
                        </tr>
                    } @empty {
                        <td colspan="14" class="text-center">
                            {{ 'table_noResults' | translate: 'online' : 'common' }}
                        </td>
                    }
                </tbody>
            </table>
        </div>
        <div class="text-center pb-3">
            <app-pagination
                [collectionSize]="
                    (results.sortedMeterConsumptions.length > 0
                        ? results?.sortedMeterConsumptions?.length
                        : results.sortedPercentageMeterConsumptions.length) ?? 0
                "
                [page]="results.page"
                (pageChange)="page$.next($event)"
                (pageSizeChange)="pageSize$.next($event)"></app-pagination>
        </div>
    } @else {
        <div class="alert alert-warning m-3" style="font-weight: bold">
            {{ 'common_No-data-available' | translate }}
        </div>
    }
}
